import React from "react";
import { Trans } from "react-i18next";
import { Navigate } from "react-router-dom";
import { SFDashboardIcon, SFTabsLayout } from "@sf-core";
import SkillCloud from "../screens/skillCloud";
import AcademiesDashboard from "../screens/academiesDashboard";
import BenchmarkReport from "../screens/benchmarkReport";
import { Claims } from "./claims";
import PATHS from "./paths";

const ROUTES = [
  {
    path: PATHS.REPORTING,
    component: <Navigate to={PATHS.REPORTING_ACADEMIES_DASHBOARD} />,
  },
  {
    path: PATHS.REPORTING,
    permissions: [Claims.AdminReportingView],
    label: <Trans i18nKey="reportingRoutes.reporting" />,
    icon: <SFDashboardIcon />,
    showInSideMenu: true,
    component: (
      <SFTabsLayout
        tabs={[
          {
            path: PATHS.REPORTING_ACADEMIES_DASHBOARD,
            label: <Trans i18nKey="reportingRoutes.academiesDashboard" />,
          },
          {
            path: PATHS.REPORTING_BENCHMARK,
            label: <Trans i18nKey="reportingRoutes.benchmark" />,
          },
          {
            path: PATHS.REPORTING_SKILL_CLOUD,
            label: <Trans i18nKey="reportingRoutes.skillCloud" />,
          },
        ]}
      />
    ),
    children: [
      {
        path: PATHS.REPORTING_ACADEMIES_DASHBOARD,
        permissions: [Claims.AdminReportingView],
        titleSuffix: "reportingRoutes.academiesDashboard",
        component: <AcademiesDashboard />,
      },
      {
        path: PATHS.REPORTING_BENCHMARK,
        permissions: [Claims.AdminReportingView],
        titleSuffix: "reportingRoutes.benchmark",
        component: <BenchmarkReport />,
      },
      {
        path: PATHS.REPORTING_SKILL_CLOUD,
        permissions: [Claims.AdminReportingView],
        titleSuffix: "reportingRoutes.skillCloud",
        component: <SkillCloud />,
      },
    ],
  },
];

export default ROUTES;
